import React, { useEffect, useState } from "react";
import { PlusIcon } from "../../iconshere";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import moment from "moment";
import swal from "sweetalert";
import Swal from 'sweetalert2'

function UserWorkflows() {

  const userData = useSelector((state) => state.userSlice);

  const configData = useSelector((state) => state.configSlice);

  var { apiBaseUrl } = configData.config;

  const { token } = userData;

  const [list, setList] = useState([]);



  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const location = useLocation()

  const [selectedIds, setSelectedIds] = useState([]);



  const handleCheckboxChange = (id) => {

    if (selectedIds.includes(id)) {

      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else {

      setSelectedIds([...selectedIds, id]);
    }
  };

  const { userID } = useParams()


  const getWorkflowList = async () => {

    await axios
      .get(`${apiBaseUrl}/api/workflow/findworkworkflowbyusers/${userData?.user?.group?.uuid}`, {
        headers: headers,
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            setList([...response.data.list])
          }
        }
      })
      .catch(function (err) {
        console.log(err)
      });
  };

  const assignworkflowtoUser = async () => {
    try {
      var _data = {
        workflowIds: selectedIds,
        userid: {
          value: location.state.data.uuid,
          email: location.state.data.email,
          label: location.state.data.name
        }
      }

      let { data } = await axios.post(`${apiBaseUrl}/api/workflow/assignworkflowtouser`, _data, { headers: headers });
      if (data.success == true) {

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "User Assigned To WorkFlow",
          showConfirmButton: false,
          timer: 1500
        });
      }


    } catch (err) {
      console.log(err)
    }
  }



  useEffect(() => {
    getWorkflowList()
  }, [])



  const getInitials = (name) => {
    const words = name.split(" ");
    if (words.length >= 2) {
      return words[0][0].toUpperCase() + words[1][0].toUpperCase();
    } else if (words.length === 1) {
      return words[0][0].toUpperCase();
    } else {
      return ""; // No initials available
    }
  };


  return (
    <>
      <div className="main-content">
        <div className="page-content  pt-3">
          <div className="container-fluid">
            <div className="row corpheader">
              <div className="col-md-6 d-flex justify-content-start">
                <div class="moudlendgroup d-flex align-items-center">
                  {location.state.data.avatar ? (
                    <img src={location.state.data.avatar} alt="User Avatar" />
                  ) : (
                    <div className="initials-avatar">
                      {getInitials(location.state.data.name)}
                    </div>
                  )}
                  {/* <img src={location.state.data.avatar} /> */}
                  <div class="data">
                    <h5> {location.state.data.name} </h5>
                    <p>Assign Workflows</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 d-flex justify-content-end">
                <div className="text-md-right">
                  {selectedIds.length > 0 ?
                    <button className="redbtn" onClick={() => assignworkflowtoUser()}>
                      <PlusIcon />
                      Assign Workflow
                    </button>
                    :
                    <button className="redbtn" style={{ cursor: "no-drop" }} >
                      <PlusIcon />
                      Assign Workflow
                    </button>
                  }
                </div>
              </div>
            </div>
            <div className="row">
              <div className="table-responsive workflowtb">
                <table className="table align-middle table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th>Workflow Name</th>
                      <th className="text-center">Workflow ID</th>
                      <th className="text-center">Current Version</th>
                      <th className="text-center">Last Updated</th>
                      <th style={{ textAlign: "center" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.length && list.map((e, i) => {

                      return (
                        <tr>
                          <td> {e.workflow_name} </td>
                          <td className="text-center"> {e.workflow_unique_name} </td>
                          <td className="text-center">
                            <span> {e?.version[0]?.version} </span>
                          </td>
                          <td className="text-center"> {moment(e.updatedAt).format("DD-MM-YYYY")} </td>

                          <td>
                            <div className="d-flex justify-content-center align-items-center">
                              <input
                                type="checkbox"
                                style={{ marginLeft: "0" }}
                                className="form-check-input allUser"
                                checked={e?.user_aligned?.filter((aligned) => aligned?.value === userID)[0]?.value}
                                onChange={() => {
                                  const isChecked = e?.user_aligned.some((aligned) => aligned?.value === userID);


                                  if (!isChecked) {
                                    handleCheckboxChange(e._id);
                                  }
                                }}
                              />
                            </div>
                          </td>

                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserWorkflows;
